/**
 * Note: due to the setup and webpack config of this project
 * we do not need to export the files, because every js file is being imported into the 'assets/customer.js' file
 * meaning that these are globally accessible.
 * @TODO - update webpack config to have single (or multiple) js entry point instead of concatinating each js file
 */
export function setCookie(name, value, exdays = 0) {
  var expires = '';

  if (exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    expires = "expires=" + d.toUTCString();
  }

  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}